import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import about_us_img from "../src/assets/images/about-us-img.jpeg";
import about_us_img2 from "../src/assets/images/about-us-img-2.png";
import doctors from "../src/assets/images/doctors.jpg";
import realestate from "../src/assets/images/real-estate.jpg";
import podcasts from "../src/assets/images/podcasts.jpg";
import "./App.css";
import Header from "./component/Header";
import HeroBanner from "./component/HeroBanner";
import Clients from "./component/Clients";
import Testimonials from "./component/Testimonials";
import Contact from "./component/Contact";
import Footer from "./component/Footer";

function App() {
  const [isSticky] = useState(false);

  useEffect(() => {
    window.addEventListener("load", () => {
      const preloader = document.getElementById("preloader");

      // Trigger loading animation
      preloader.classList.add("is-loading");

      // After animation ends, hide it
      setTimeout(() => {
        preloader.classList.remove("is-loading");
        preloader.classList.add("is-loaded");
      }, 3000); // matches your transitions (1.5s + 1.5s buffer)
    });

    const cursor = document.querySelector(".cursor");
    const outline = document.querySelector(".cursor2");

    document.addEventListener("mousemove", (e) => {
      // Move both inner and outer cursors
      cursor.style.top = `${e.clientY}px`;
      cursor.style.left = `${e.clientX}px`;

      outline.style.top = `${e.clientY}px`;
      outline.style.left = `${e.clientX}px`;
    });
  }, []);

  return (
    <>
      <section id="preloader" className="pxl-loader style-2">
        <div className="line"></div>
        <div className="split top"></div>
        <div className="split bottom"></div>
      </section>
      <section className="cursor"></section>
      <section className="cursor2"></section>
      <Header isSticky={isSticky} />
      <HeroBanner />
      <section className="about-us bg-color" id="about-us">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="sub-title">About Us</h2>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-4 col-sm-12">
              <div className="about-us-img-content">
                <div className="position-relative">
                  <div className="about-us-img">
                    <div className="img">
                      <img className="img-fluid" src={about_us_img} alt="" />
                    </div>
                    <div className="content">
                      <h3 className="funnel-display">
                        Driven by Strategy. Powered by Creativity.
                      </h3>
                      {/* <div className="inter">We don’t just believe in growing your business — we actually make it happen. At our agency, digital marketing is not only about promotions and ads; it’s about building a strong brand that people recognize, trust, and remember. From creating impactful content to generating real engagement and leads, we help your business stand out across every digital platform. Our focus is simple — build your brand, grow your audience, and deliver real results.</div> */}
                    </div>
                  </div>
                  <a href="#about-us" className="button about-us-btn">
                    About Us
                    <i className="fa-sharp fa-regular fa-plus"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-9 col-md-8 col-sm-12">
              <div className="about-us-content">
                <h2
                  className="main-title split-text"
                  id="split-text"
                  data-splitting
                >
                  Meet the Powerful Minds who Helps Brands Grow Faster Through
                  Strategy, Innovation, Creativity, and Results-Driven Campaigns
                </h2>
                <div className="content">
                  <p className="title-descr">
                    We don’t just believe in growing your business — we actually
                    make it happen. At our agency, digital marketing is not only
                    about promotions and ads; it’s about building a strong brand
                    that people recognize, trust, and remember. From creating
                    impactful content to generating real engagement and leads,
                    we help your business stand out across every digital
                    platform. Our focus is simple — build your brand, grow your
                    audience, and deliver real results.
                  </p>
                </div>
                <div className="about-us-img-2">
                  <img className="img-fluid" src={about_us_img2} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="services" id="services">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="sub-title text-center mb-4">Services</h2>
              <h2 className="main-title text-center split-text" id="split-text" data-splitting>
                Services That Grow Your Brand Digitally
              </h2>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="service-list">
            <div className="row">
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-blue">
                  <i className="hgi hgi-stroke hgi-rounded hgi-seo"></i>
                  <h3 className="cormorant-garamond">SEO</h3>
                  <p>Improve search rankings and drive consistent organic traffic that delivers long-term results.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-golden">
                  <i className="hgi hgi-stroke hgi-rounded hgi-promotion"></i>
                  <h3 className="cormorant-garamond">SMM</h3>
                  <p>Build brand awareness through strategic social media marketing that drives engagement and growth.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-blue">
                  <i className="hgi hgi-stroke hgi-rounded hgi-meta"></i>
                  <h3 className="cormorant-garamond">Meta Ads</h3>
                  <p>Reach your ideal audience with high-performing Meta ad campaigns that drive measurable business growth.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-golden">
                  <i className="hgi hgi-stroke hgi-rounded hgi-google"></i>
                  <h3 className="cormorant-garamond">Google Ads</h3>
                  <p>Generate quality leads and increase conversions through optimized Google Ads campaigns.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-blue">
                  <i className="hgi hgi-stroke hgi-rounded hgi-youtube"></i>
                  <h3 className="cormorant-garamond">YouTube Ads</h3>
                  <p>Capture attention with engaging YouTube video ads that boost brand awareness and sales.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-golden">
                  <i className="hgi hgi-stroke hgi-rounded hgi-linkedin-01"></i>
                  <h3 className="cormorant-garamond">LinkedIn Ads</h3>
                  <p>Target professionals and build your brand’s authority through strategic LinkedIn ad campaigns.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-blue">
                  <i className="hgi hgi-stroke hgi-rounded hgi-brush"></i>
                  <h3 className="cormorant-garamond">Graphic Design</h3>
                  <p>Capture attention with engaging YouTube video ads that boost brand awareness and sales.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-golden">
                  <i className="hgi hgi-stroke hgi-rounded hgi-video-01"></i>
                  <h3 className="cormorant-garamond">Video Editing</h3>
                  <p>Produce polished, engaging videos that capture attention and strengthen your brand identity.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-blue">
                  <i className="hgi hgi-stroke hgi-rounded hgi-web-programming"></i>
                  <h3 className="cormorant-garamond">Website Designing</h3>
                  <p>Design modern, responsive websites that deliver exceptional user experiences and strengthen your brand.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-golden">
                  <i className="hgi hgi-stroke hgi-rounded hgi-developer"></i>
                  <h3 className="cormorant-garamond">Website Development</h3>
                  <p>Develop fast, secure, and scalable websites with seamless functionality for every business need.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-blue">
                  <i className="hgi hgi-stroke hgi-rounded hgi-shopping-cart-01"></i>
                  <h3 className="cormorant-garamond">E-commerce</h3>
                  <p>Build secure online stores that simplify shopping and help your business increase sales.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="service-item service-item-golden">
                  <i className="hgi hgi-stroke hgi-rounded hgi-podcast"></i>
                  <h3 className="cormorant-garamond">Podcast</h3>
                  <p>Produce engaging podcasts with professional recording, editing, publishing, and audience growth.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="portfolio bg-color" id="portfolio">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="sub-title text-center mb-4">Portfolio</h2>
              <h2
                className="main-title text-center split-text"
                id="split-text"
                data-splitting
              >
                Digital Success Stories We’re Proud Of
              </h2>
            </div>
            <div className="portfolio-content">
              <div className="row">
                <div className="col-md-4">
                  <div className="portfolio-item">
                    <div className="portfolio-item-showcase">
                      <div className="image">
                        <img className="img-fluid w-100" src={doctors} alt="" />
                      </div>
                    </div>
                    <h6 className="title">Doctors</h6>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="portfolio-item">
                    <div className="portfolio-item-showcase">
                      <div className="image">
                        <img className="img-fluid w-100" src={realestate} alt="" />
                      </div>
                    </div>
                    <h6 className="title">E-Commerce</h6>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="portfolio-item">
                    <div className="portfolio-item-showcase">
                      <div className="image">
                        <img className="img-fluid w-100" src={realestate} alt="" />
                      </div>
                    </div>
                    <h6 className="title">Real Estate</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Clients />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
